import { Controller } from "stimulus";
import MicroModal from "micromodal";

let cache = {};

export default class extends Controller {
  static targets = ["rell", "description", "iconName", "errorDescription", "frame", "spinButton", "amount", "modal", "playable"];
  companyId = new URLSearchParams(window.location.search).get("id");
  stopTimeout;
  timeOut;
  config = {
    inverted: true, // true: reels spin from top to bottom; false: reels spin from bottom to top
    onSpinStart() {
      this.spinButtonTarget.disabled = true;
  
      if (this.frameTarget.classList.contains("active")) {
        this.frameTarget.classList.remove("active");
      }
    },
    onSpinEnd(isWin, description, iconName, balance, html) {
      this.spinButtonTarget.disabled = false;
      this.amountTarget.innerText = balance.toString();
  
      if (isWin) {
        this.showModalThenWin(html);
        this.frameTarget.classList.add("active");
      }
      // if (this.autoPlayCheckbox.checked) {
      //   return window.setTimeout(() => this.spin(), 200);
      // }
    },
    onSpinError(description) {
      this.showModalThenError(description);
      this.spinButtonTarget.disabled = false;
    }
  };

  currentSymbols = [
    ["gift", "gift", "gift"],
    ["gift", "gift", "gift"],
    ["gift", "gift", "gift"],
  ];

  nextSymbols = [
    ["gift", "gift", "gift"],
    ["gift", "gift", "gift"],
    ["gift", "gift", "gift"],
  ];

  reels = [];
  
  connect() {
    Symbol.preload();

    this.reels = this.rellTargets.map(
      (reelContainer, idx) =>
        new Reel(reelContainer, idx, this.currentSymbols[idx])
    );
  }

  start() {
    clearTimeout(this.stopTimeout);
    clearTimeout(this.timeOut);
    if (parseInt(this.amountTarget.innerText) < 10) {
      this.showModalThenError('You dont have enough points to play');
      return;
    }

    if (this.playableTarget.value === "false" ) {
      this.showModalThenMessage();
      return;
    }

    this.currentSymbols = this.nextSymbols;
    this.nextSymbols = [
      [Symbol.random(), Symbol.random(), Symbol.random()],
      [Symbol.random(), Symbol.random(), Symbol.random()],
      [Symbol.random(), Symbol.random(), Symbol.random()],
    ];

    this.config.onSpinStart.apply(this);

    this.reels.forEach(reel => {
      reel.renderSymbols(this.nextSymbols[reel.idx]);
      reel.spin();
    })

    this.postData(`/web/games/slot?id=${this.companyId}`)
      .then((data) => {
         return Promise.all(
          this.reels.map((reel, i) => {
            return reel.stop(data?.ids[i]);
          })
        ).then((resolve) => {
          this.config.onSpinEnd.bind(this)(data?.win, data?.description, data?.ids[0], data?.balance, data?.result_html);
          return resolve;
        });
      })
      .catch((e) => {
        this.config.onSpinError.bind(this)(`Error occured: ${e}`);

        this.reels.forEach(reel => {
          reel.error();
        })
      });
  }

  showModalThenWin(html) {
    MicroModal.show('slot-game-modal');
    this.modalTarget.querySelector(".content").innerHTML = html
  }

  showModalThenError(description) {
    this.errorDescriptionTarget.innerText = description;
    MicroModal.show('error-modal');
  }

  showModalThenMessage(){
    MicroModal.show('default-message-modal');
  }

  showModalPrizes() {
    MicroModal.show('prizes-modal');
  }

  async postData(url = "", data = {}) {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    if (response.status === 200) {
      return await response.json();
    }

    throw Error(response.status);
  }
}

class Reel {
  constructor(reelContainer, idx, initialSymbols) {
    this.reelContainer = reelContainer;
    this.idx = idx;

    this.symbolContainer = document.createElement("div");
    this.symbolContainer.classList.add("icons");
    this.reelContainer.appendChild(this.symbolContainer);

    this.animation = this.animationStart();
    this.animation.cancel();

    initialSymbols.forEach((symbol) =>
      this.symbolContainer.appendChild(new Symbol(symbol).img)
    );
  }

  get factor() {
    return 1 + Math.pow(this.idx / 2, 2);
  }

  renderSymbols(nextSymbols) {
    const fragment = document.createDocumentFragment();

    for (let i = 3; i < 3 + Math.floor(this.factor) * 10; i++) {
      const icon = new Symbol(
        i >= 10 * Math.floor(this.factor) - 2
          ? nextSymbols[i - Math.floor(this.factor) * 10]
          : undefined
      );
      fragment.appendChild(icon.img);
    }

    this.symbolContainer.appendChild(fragment);
  }

  spin() {
    this.animation.play();

    this.timeOut = setTimeout(() => {
      this.animation.finish();
      this.animation = this.animationInfinity();
      this.animation.play();
    }, this.factor * 1000);
  }

  error() {
    clearTimeout(this.timeOut);
    this.animation.finish();
    this.animation.cancel();
    
    const max = this.symbolContainer.children.length - 3;

    for (let i = 0; i < max; i++) {
      this.symbolContainer.firstChild.remove();
    }
  }

  stop(value) {    
    const animationPromise = new Promise(
      (resolve) => (this.animation.onfinish = resolve)
    );

    const timeoutPromise = new Promise((resolve) => {
      if (Symbol.default_symbols.includes(value)){
        this.symbolContainer.children[
          this.symbolContainer.children.length - 2
        ].src = require(`/app/assets/images/slot-game/${value}.svg`);
      }
      else{
        this.symbolContainer.children[
          this.symbolContainer.children.length - 2
        ].src = value;
      }

      this.stopTimeout = setTimeout(() => resolve(value), this.factor * 1000);
    });

    return Promise.race([animationPromise, timeoutPromise]).then((resolve) => {
      if (this.animation.playState !== "finished") {
        this.animation.finish();
        this.animation = this.animationStart();
        this.animation.cancel();
      }
      const max = this.symbolContainer.children.length - 3;

      for (let i = 0; i < max; i++) {
        this.symbolContainer.firstChild.remove();
      }

      return resolve[1];
    });
  }

  animationStart() {
    return this.symbolContainer.animate(
      [
        { transform: "none", filter: "blur(0)" },
        { filter: "blur(0)", offset: 0.5 },
        {
          transform: `translateY(-${
            ((Math.floor(this.factor) * 10) /
              (3 + Math.floor(this.factor) * 10)) *
            100
          }%)`,
          filter: "blur(2px)",
        },
      ],
      {
        duration: this.factor * 1300,
        easing: "ease-in",
      }
    );
  }

  animationInfinity() {
    return this.symbolContainer.animate(
      [
        { transform: "none", filter: "blur(2px)" },
        {
          transform: `translateY(-${
            ((Math.floor(this.factor) * 10) /
              (3 + Math.floor(this.factor) * 10)) *
            100
          }%)`,
          filter: "blur(2px)",
        },
      ],
      {
        duration: this.factor * 1300,
        easing: "linear",
        iterations: 50,
      }
    );
  }
}

class Symbol {
  constructor(name = Symbol.random()) {
    if (cache[name]) {
      this.img = cache[name].cloneNode();
    } else {
      this.img = new Image();
      if (Symbol.default_symbols.includes(name)){
        this.img.src = require(`/app/assets/images/slot-game/${name}.svg`);
      }
      else{
        this.img.src = name;
      }
      this.img.style.objectFit = "contain";
      cache[name] = this.img;
    }
  }

  static preload() {
    Symbol.symbols.forEach((symbol) => new Symbol(symbol));
  }

  static get default_symbols(){
    return ["gift", "coupon-10", "coupon-50", "coupon-100",
      "king", "heart", "smile", "gift", "1+1", "2+1", "2+2", "achieve", 
      "baget", "beer", "breacfast", "bread", "burger-1", "burger-red-1",
      "burger", "cal-check", "cocktail", "diamond", "emotionless-smile", 
      "euro", "fish-1", "fish", "hotdog", "icecream-1", "icecream", 
      "notification", "pasta", "percent", "pie", "pizza", "pommes", 
      "red-pocket", "salad", "semmel", "soup", 
      "steak", "tea", "wine-bottle", "wine",
      "croissant", "cola" , "darkbread", "sushibox", "champagne"]
  }

  static get symbols() {
    const icons_array = document.getElementById("game-icons").value;
    const data = icons_array.split(" ")
    return data
  }

  static random() {
    return this.symbols[Math.floor(Math.random() * this.symbols.length)];
  }

  static win() {
    return this.symbols[2 + Math.floor(Math.random() * 2)];
  }
}
